import api from "../axiosInstance";

export const createMerchandiseCategory = (payload) => async (dispatch) => {
  try {
    const response = await api.post(`/merchandiseCategory/`, {
      image: payload.image,
      name: payload.name,
    });
    dispatch({
      type: "CREATE_MERCHANDISE_CATEGORY",
      payload: response.data.data,
    });
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const getMerchandiseCategories = (payload) => async (dispatch) => {
  try {
    const response = await api.get(
      `/merchandiseCategory/?${payload.page ? `page=${payload.page}` : ""}&${
        payload.limit ? `limit=${payload.limit}` : ""
      }`
    );
    dispatch({
      type: "GET_MERCHANDISE_CATEGORIES",
      payload: response.data.data,
    });
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const getAllMerchandiseCategories = async () => {
  try {
    const response = await api.get(`/merchandiseCategory/all`);
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const editMerchandiseCategory = (payload) => async (dispatch) => {
  try {
    const payloadIs = {
      image: payload.image,
      name: payload.name,
    };
    const response = await api.put(
      `/merchandiseCategory/?id=${payload.id}`,
      payloadIs
    );
    dispatch({
      type: "EDIT_MERCHANDISE_CATEGORY",
      payload: response.data.data,
    });
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const deleteMerchandiseCategory = (payload) => async (dispatch) => {
  try {
    const response = await api.delete(`/merchandiseCategory/?id=${payload.id}`);
    dispatch({
      type: "DELETE_MERCHANDISE_CATEGORY",
      payload: payload.id,
    });
    return response.data.data;
  } catch (err) {
    throw err;
  }
};
